(ns ui.view.card.shared-components.entity-peek
  (:require
   [ui.util :as uu]
   [ui.components.button.view :as button]
   [ui.components.skeleton.view :as skeleton]
   [ui.components.radix-ui.accordion.view :refer [accordion-primitive-root
                                                  accordion-primitive-item
                                                  accordion-primitive-content]]
   [clojure.string :as string]
   [common.localization :as loc]
   [ui.components.rich-text.tiptap :as tiptap]))

(defn accordion-item
  [props & children]
  (let [children (if (map? props) children (cons props children))
        props (if (map? props) props {})]
    [accordion-primitive-item
     props
     (into [:<>] children)]))

(defn accordion-content
  [& children]
  [accordion-primitive-content
         ;; For some reason the animation would not work written in tailwind css
   {:class "AssociatedEntitiesCardEntityPeekAccordionContent"}
   (into [:div {:class "pt-0 h-full w-full grow"}] children)])

(defn divider
  [{:keys [class]}]
  [:div {:class (uu/cm "h-px bg-complement-light" class)}])

(defn header
  [{:keys [data loading? close entity-type edit preview-mode?]}]
  (let [title (:title data)]
    [:div
     {:class "flex items-center justify-between"}
     [:div
      (if-not loading?
        [:p {:class "font-medium text-md line-clamp-2"} title]
        [skeleton/view {:class "h-5 w-36"}])]

     [:div
      {:class "h-full flex gap-2 items-center"}
      (when-not preview-mode?
        [button/square-secondary-open
         {:tooltip (loc/tr :edit-entity [(-> entity-type
                                             loc/tr
                                             string/lower-case)])
          :on-click edit}
         [:i {:class "fal fa-pen"}]])
      [:div
       [button/sm-secondary-hollow
        {:on-click close
         :tooltip (loc/tr :close)
         :class "rounded-full px-0 py-0 h-8 w-8"}
        [:i.fal.fa-times]]]]]))

(defn materialized-value->string
  [materialized-value]
  (if (or (vector? materialized-value)
          (list? materialized-value))
    (->> materialized-value
         (map :label)
         (string/join "; "))
    (str materialized-value)))

(defn peek-content
  [{:keys [data]}]
  [:div
   {:class "flex flex-col gap-5 grow"}
   (->> data
        :data
        (map-indexed
         (fn [idx row-data]
           (let [field-label (:field-label row-data)
                 data-type (:data-type row-data)
                 materialized-value (:materialized-value row-data)
                 str-value (materialized-value->string materialized-value)]
             ^{:key (str "row-" idx)}
             [:div
              [:p
               {:class "text-sm font-medium m-0 text-neutral-600"}
               field-label]
              (if (= data-type :data.type/text-richtext)
                [:div
                 ;; HACK
                 {:class "[&>*]:pt-1 [&_.ProseMirror]:!m-0 [&_.ProseMirror]:!text-md"}
                 [tiptap/viewer {:value str-value}]]
                [:p
                 {:class "text-neutral-700"}
                 str-value])]))))])

(defn component
  [{:keys [full-screen?] :as props}]
  [:div {:class (uu/cm "h-full w-64 xl:w-80 2xl:w-96"
                           ;; TODO fix this css, accordion causes some pain with dynamic sizes
                       (when full-screen?
                         (str "w-[calc(100vw/3)] xl:w-[calc(100vw/3)] 2xl:w-[calc(100vw/3)]")))}
   [:div
    {:class "flex flex-col mb-5 gap-2 ml-5 pl-5 border border-y-0 border-r-0 h-full min-h-60 overflow-hidden"}
    [header props]
    [divider]
    [peek-content props]]])

(defn expandable-peek-view
  [{:keys [open?] :as props}]
  [accordion-primitive-root
   {:type "single"
    :asChild true
    :orientation :horizontal
    :value (when open? "entity-peek")
    :collapsible true}

   [accordion-item
    {:value "entity-peek"
     :asChild true}
    [:div
     {:class (uu/cm "flex flex-col items-start")}
     [accordion-content
      [component props]]]]])

(defn view
  [props]
  [expandable-peek-view props])
